import React, { useState, useEffect } from "react";
import AuthorityLayout from "../../../components/layout/AuthorityLayout";
import PaymentHeader from "../payment/PaymentHeader";

const defaultPrayerTimes = [
  {
    name: "Fajr",
    athan: { hour: "03", minutes: "56" },
    iqamah: { hour: "03", minutes: "57" },
    timeValues: "03:56",
  },
  {
    name: "Dhuhr",
    athan: { hour: "13", minutes: "15" },
    iqamah: { hour: "13", minutes: "16" },
    timeValues: "13:15",
  },
  {
    name: "aBC",
    athan: { hour: "15", minutes: "11" },
    iqamah: { hour: "15", minutes: "12" },
    timeValues: "15:11",
  },
  {
    name: "Asr",
    athan: { hour: "16", minutes: "11" },
    iqamah: { hour: "16", minutes: "12" },
    timeValues: "16:11",
  },
  {
    name: "Esha",
    athan: { hour: "02", minutes: "11" },
    iqamah: { hour: "23", minutes: "12" },
    timeValues: "02:11",
  },
];

const PrayerTime = () => {
  const [time, setTime] = useState({});
  const [prayerItems, setPrayerItems] = useState([]);

  const tick = () => {
    // Get the current time
    const currentTime = new Date();

    // Find the next time in the current day
    let nextTime = null;
    let highlightItem = null;

    for (let i = 0; i < defaultPrayerTimes.length; i++) {
      const timeParts = defaultPrayerTimes[i].timeValues.split(":");
      const time = new Date();
      time.setHours(parseInt(timeParts[0]));
      time.setMinutes(parseInt(timeParts[1]));
      if (time > currentTime && (nextTime === null || time < nextTime)) {
        nextTime = time;
        highlightItem = defaultPrayerTimes[i];
      }
    }

    // If the next time is not found in the current day, search in the next day
    if (nextTime === null && highlightItem === null) {
      const nextDay = new Date(currentTime.getTime() + 24 * 60 * 60 * 1000);
      for (let i = 0; i < defaultPrayerTimes.length; i++) {
        const timeParts = defaultPrayerTimes[i].timeValues.split(":");
        const time = new Date(nextDay);
        time.setHours(parseInt(timeParts[0]));
        time.setMinutes(parseInt(timeParts[1]));
        if (nextTime === null || time < nextTime) {
          nextTime = time;
          highlightItem = defaultPrayerTimes[i];
        }
      }
    }

    // Calculate the distance to the next time
    var distanceMs = nextTime.getTime() - currentTime.getTime();
    var distanceHours = Math.floor(distanceMs / 3600000);
    var distanceMinutes = Math.floor((distanceMs % 3600000) / 60000);

    // prayer item update
    const updatedPrayerItems = defaultPrayerTimes.map((pray) =>
      pray.name === highlightItem.name ? { ...pray, highlight: true } : pray
    );

    setTime({
      ...time,
      hours: distanceHours,
      minutes: distanceMinutes,
    });
    setPrayerItems(updatedPrayerItems);
  };

  useEffect(() => {
    let timerID = setInterval(() => tick(), 5000);
    return () => clearInterval(timerID);
  });

  return (
    <AuthorityLayout>
      <PaymentHeader />
      <div className="flex gap-x-10">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </AuthorityLayout>
  );
};

export default PrayerTime;
